import { all } from "redux-saga/effects";
import addressSaga from "./addressSaga";
import brandSaga from "./brandSaga";
import categorySaga from "./categorySaga";
import ordersSaga from "./ordersSaga";
import productSaga from "./productSaga";
import shippingSaga from "./shippingSaga";
import subcategorySaga from "./subcategorySaga";
import userSaga from "./userSaga";
import resourceSaga from "./resourceSaga";
import statisticsSaga from "./statisticsSaga";
import prescriptionSaga from "./prescriptionSaga";


export default function* rootSaga() {
    yield all([
        productSaga(),
        categorySaga(),
        subcategorySaga(),
        userSaga(),
        shippingSaga(),
        addressSaga(),
        ordersSaga(),
        brandSaga(),
        resourceSaga(),
        statisticsSaga(),
        prescriptionSaga(),
    ]);
}